export default __webpack_public_path__ + "static/media/welcome2.78d878af.jpg";